module.exports = __webpack_public_path__ + "media/audio23.a8fee529.mp3";